import "react-toastify/dist/ReactToastify.css";
import AttributeBars from "../../Dashboard/Component/CompAttributes/CompAttributes";
import { transformDataForMultibarChart } from "../../../utils/helpers";
import { useContext } from "react";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";

export default function AttributesOverview() {
    const discoveryCtx = useContext(DiscoveryContext);
    let attributeRef = discoveryCtx.positive_negative_attributes;
    let selectedLLM = discoveryCtx.state.selectedLLM;
    const selectedCategory = discoveryCtx.state.selectedCategory
    let positiveAttributes = {};
    const id = "Attributes_Overview";
      const { checked, uniqueKey } = useIsSelectedSection({ id });
    

        if (attributeRef?.[selectedLLM]?.[selectedCategory]?.length) { 
           attributeRef?.[selectedLLM]?.[
                selectedCategory
            ]?.forEach((compitier)=>{
               positiveAttributes[compitier.name] = compitier.positives?.reduce((a, b) => {
                return { ...a, [b.name]: b.value };
            }, {});
        })
    }

    let negativesAttributes = {};

   if (attributeRef?.[selectedLLM]?.[selectedCategory]?.length) { 
           attributeRef?.[selectedLLM]?.[
                selectedCategory
            ]?.forEach((compitier)=>{
               negativesAttributes[compitier.name] = compitier.negatives?.reduce((a, b) => {
                return { ...a, [b.name]: b.value };
            }, {});
        })
    }


    let positiveAttBarChartData =
        transformDataForMultibarChart(positiveAttributes, false);
    let negativeAttBarChartData =
        transformDataForMultibarChart(negativesAttributes, false);

    return (
        <>
             <div className="Heading-checkbox">
                    <h5>Positive and Negative Attributes</h5>
            
                    {discoveryCtx.state.showReportCheckbox && (
                      <Checkbox
                        checked={checked}
                        onChange={() => {
                          discoveryCtx?.clickComponentCheckbox({
                            uniqueKey,
                            filter: {
                              id: id,
                              title: "Positive and Negative Attributes",
                              tab: tab.competitiveOverview,
                              uniqueKey
                            },
                            checked,
                            id,
                          });
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    )}
                  </div>
            <hr />
            <AttributeBars
                negativeAttributes={negativeAttBarChartData}
                positiveAttributes={positiveAttBarChartData}
            />
        </>
    );
}


/*
 llmData=["gpt4-0","gemini"];

 data={
 gpt4-0:{
 project_management:{
 "consting":4,
 " accessibility":5
 }
 }
 }

filterArr=["project_management","timeSheet"]
*/

